import loadable from '@loadable/component';
import { OverlaySpinner } from '@ankr.com/ui';

const StatisticsPage = loadable(
  async () => {
    const module = await import('./StatisticsPage');

    return module.StatisticsPage;
  },
  {
    fallback: <OverlaySpinner />,
  },
);

export const StatisticsPageContainer = () => <StatisticsPage />;
